import * as React from 'react';
import * as styles from './styles.css';
import { ArticleParagraph2 } from '@cian/ui-kit';

export interface ISearchTextHistoryItemProps {
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

export const SearchTextHistoryItem: React.FC<ISearchTextHistoryItemProps & React.PropsWithChildren> = props => {
  return (
    <div className={styles['container']} onClick={props.onClick}>
      <ArticleParagraph2>{props.children}</ArticleParagraph2>
    </div>
  );
};

SearchTextHistoryItem.displayName = 'SearchTextHistoryItem';
